import React from "react";
import constants from "config/constants";
import "../styles/TermsAndConditions.css";

function TermsAndConditions() {
  return (
    <div className="terms-and-conditions-container">
      {/* Header Section */}
      <div className="header-container">
        <h1 className="terms-and-conditions-container">TERMS AND CONDITIONS</h1>
      </div>
      <div className="main-view">
        {/* Company Header */}
        <div>
          <h2>
            <span className="company-name">Hua Shen Herbs</span>
          </h2>
          <p className="effective-date">Effective Date: April 4, 2026</p>
        </div>

        {/* TERMS AND CONDITIONS SECTION */}
        <div className="terms-and-conditions-section">
          <h2>
            TERMS, TELEHEALTH CONSENT, HERBAL CONSENT, AND PRODUCT DISCLOSURES
          </h2>
          <p>
            By accessing this website, purchasing products, or participating in
            consultations with{" "}
            <span className="company-name">Hua Shen Herbs</span> ("we," "us," or
            "our"), you agree to the following:
          </p>

          <h3>1. Scope of Services</h3>
          <p>
            <span className="company-name">Hua Shen Herbs</span> provides
            traditional Chinese medicine (TCM) consultations and customized
            herbal formulations based on individualized assessments rooted in
            traditional Eastern medical theory. Services are provided for
            wellness support and are not a substitute for conventional medical
            care.
          </p>

          <h3>2. Not Medical Advice</h3>
          <p>
            Information provided through this website or consultations is for
            educational and wellness purposes only and is not intended to
            diagnose, treat, cure, or prevent any disease. Always consult a
            licensed medical provider regarding any health condition.
          </p>

          <h3>3. Client Responsibility</h3>
          <p>
            You agree to provide accurate and complete information regarding
            your health history, medications, supplements, and allergies.
            Outcomes may vary based on individual constitution and compliance.
          </p>
        </div>

        {/* TELEHEALTH CONSENT SECTION */}
        <div className="terms-and-conditions-section">
          <h2>TELEHEALTH CONSENT</h2>
          <p>
            By engaging in virtual consultations with{" "}
            <span className="company-name">Hua Shen Herbs</span>, you
            acknowledge and agree:
          </p>
          <ul>
            <li>
              Telehealth involves the use of electronic communication to enable
              health-related services when distance separates practitioner and
              client
            </li>
            <li>
              There are potential risks including interruptions, unauthorized
              access, or technical difficulties
            </li>
            <li>
              Telehealth may not be appropriate for all conditions and in-person
              care may be recommended when necessary
            </li>
            <li>You may withdraw consent at any time</li>
          </ul>
          <p>
            You consent to receive consultations, recommendations, and wellness
            guidance via telehealth platforms.
          </p>
        </div>

        {/* HERBAL MEDICINE CONSENT AND WAIVER SECTION */}
        <div className="terms-and-conditions-section">
          <h2>HERBAL MEDICINE CONSENT AND WAIVER</h2>
          <p>
            By purchasing or consuming customized herbal formulations from{" "}
            <span className="company-name">Hua Shen Herbs</span>, you
            acknowledge:
          </p>
          <ul>
            <li>
              Herbal formulas are based on traditional Chinese medicine
              principles and individualized assessment
            </li>
            <li>
              These products are not evaluated by the Food and Drug
              Administration
            </li>
            <li>Results vary and are not guaranteed</li>
            <li>
              You understand the importance of following dosage instructions
              precisely
            </li>
          </ul>

          <h3>You agree to:</h3>
          <ul>
            <li>
              Disclose all known allergies, sensitivities, medications, and
              conditions
            </li>
            <li>
              Stop use immediately and seek medical care if any adverse reaction
              occurs
            </li>
          </ul>

          <p>
            You voluntarily assume all responsibility for the use of herbal
            products and release{" "}
            <span className="company-name">Hua Shen Herbs</span> from liability
            related to their use, except where prohibited by law.
          </p>
        </div>

        {/* PAYMENT AND REFUND POLICY SECTION */}
        <div className="terms-and-conditions-section">
          <h2>PAYMENT AND REFUND POLICY</h2>
          <p>
            All customized herbal formulations are final sale due to their
            personalized nature. No refunds or exchanges will be issued once
            prepared.
          </p>
          <p>Consultation fees are non-refundable unless otherwise stated.</p>
        </div>

        {/* FSA / HSA ELIGIBILITY DISCLAIMER SECTION */}
        <div className="terms-and-conditions-section">
          <h2>FSA / HSA ELIGIBILITY DISCLAIMER</h2>
          <p>
            Services and products offered by{" "}
            <span className="company-name">Hua Shen Herbs</span> may be eligible
            for reimbursement through Flexible Spending Accounts (FSA) or Health
            Savings Accounts (HSA); however:
          </p>
          <ul>
            <li>Eligibility is determined solely by your plan provider</li>
            <li>A Letter of Medical Necessity (LMN) may be required</li>
            <li>We do not guarantee reimbursement</li>
          </ul>
          <p>
            Receipts may include service descriptions and dates but do not
            constitute a medical claim or insurance billing.
          </p>
        </div>

        {/* LIMITATION OF LIABILITY SECTION */}
        <div className="terms-and-conditions-section">
          <h2>LIMITATION OF LIABILITY</h2>
          <p>
            To the fullest extent permitted by law,{" "}
            <span className="company-name">Hua Shen Herbs</span> shall not be
            liable for any direct, indirect, incidental, or consequential
            damages arising from use of services or products.
          </p>
        </div>

        {/* PRODUCT LABELING AND NEW YORK COMPLIANCE SECTION */}
        <div className="terms-and-conditions-section">
          <h2>PRODUCT LABELING AND NEW YORK COMPLIANCE</h2>
          <p>
            All herbal products dispensed by{" "}
            <span className="company-name">Hua Shen Herbs</span> are labeled in
            accordance with applicable guidelines and include:
          </p>
          <ul>
            <li>Product name and/or formula description</li>
            <li>List of ingredients (when applicable)</li>
            <li>Suggested use and dosage instructions</li>
            <li>Date of preparation</li>
            <li>
              Business name:{" "}
              <span className="company-name">Hua Shen Herbs</span>
            </li>
          </ul>

          <h3>Additional disclosures:</h3>
          <ul>
            <li>
              These products are traditional herbal supplements and are not
              intended to diagnose, treat, cure, or prevent any disease.
            </li>
            <li>Keep out of reach of children.</li>
            <li>
              Consult a healthcare provider if pregnant, nursing, or taking
              medications.
            </li>
          </ul>
        </div>

        {/* INTELLECTUAL PROPERTY SECTION */}
        <div className="terms-and-conditions-section">
          <h2>INTELLECTUAL PROPERTY</h2>
          <p>
            All content, branding, and materials on this website are the
            property of <span className="company-name">Hua Shen Herbs</span> and
            may not be reproduced without permission.
          </p>
        </div>

        {/* MODIFICATIONS SECTION */}
        <div className="terms-and-conditions-section">
          <h2>MODIFICATIONS</h2>
          <p>
            We reserve the right to update these terms at any time. Continued
            use of services constitutes acceptance of any changes.
          </p>
        </div>

        {/* Contact Section */}
        <div className="privacy-policy-footer">
          <h3>CONTACT</h3>
          <div className="privacy-policy-contact">
            <strong>{"Hua Shen Herbs"}</strong>
            <br />
            {constants?.contact?.emailAddress}
            <br />
            <strong>{constants?.contact?.officeAddress}</strong>
          </div>
        </div>
      </div>
      {/* Agreement Statement */}
      <div className="terms-and-conditions-agreement">
        <p>
          By using this website and our services, you acknowledge that you have
          read, understood, and agreed to these terms.
        </p>
      </div>
    </div>
  );
}

export default TermsAndConditions;
